/**
 * PDP buy box: organize OptionSelectors output, themed variant pickers.
 */
(function () {
  var vendorMaps = null;
  var vendorSwatches = null;

  window.MSP = window.MSP || {};

  function getProductVendor() {
    var productEl = document.getElementById('product');
    return productEl && productEl.getAttribute('data-vendor')
      ? productEl.getAttribute('data-vendor').trim()
      : '';
  }

  function getVendorMaps() {
    if (vendorMaps) return vendorMaps;
    var el = document.getElementById('msp-pdp-swatch-maps');
    if (!el) return {};
    try {
      vendorMaps = JSON.parse(el.textContent);
    } catch (e) {
      vendorMaps = {};
    }
    return vendorMaps;
  }

  function getSwatchMap() {
    if (vendorSwatches) return vendorSwatches;
    var vendor = getProductVendor();
    var maps = getVendorMaps();
    vendorSwatches = (vendor && maps[vendor]) || {};
    return vendorSwatches;
  }

  function swatchUrl(value) {
    if (!value) return '';
    return getSwatchMap()[value] || '';
  }

  function getOptionLabel(select) {
    var wrapper = select.closest('.selector-wrapper');
    var labelEl = wrapper && wrapper.querySelector('label');
    if (!labelEl) return '';
    return labelEl.textContent
      .trim()
      .replace(/:$/, '')
      .toLowerCase();
  }

  function isLiteMaterial(value) {
    var v = (value || '').toLowerCase();
    return v === 'lite' || v === 'light';
  }

  function isSolidMaterial(value) {
    var v = (value || '').toLowerCase();
    return v === 'solid';
  }

  function getSelectedMaterial() {
    var selects = document.querySelectorAll('#msp-pdp-buybox .single-option-selector');
    for (var i = 0; i < selects.length; i++) {
      if (getOptionLabel(selects[i]) === 'material') {
        return selects[i].value;
      }
    }
    return '';
  }

  function isVariantOptionWrapper(node) {
    if (!node || !node.classList || !node.classList.contains('selector-wrapper')) {
      return false;
    }
    if (node.closest('.msp-pdp-buybox__actions')) return false;
    return !!node.querySelector('select.single-option-selector');
  }

  function organizeBuybox() {
    var form = document.getElementById('add-item-form');
    var selectHost = document.querySelector('.msp-pdp-buybox__options .select');
    if (!form || !selectHost) return;

    var productSelect = document.getElementById('product-select');
    var insertBefore = productSelect || null;

    for (var i = 0; i < form.children.length; i++) {
      var child = form.children[i];
      if (!isVariantOptionWrapper(child)) continue;
      if (child.parentElement === selectHost) continue;
      selectHost.insertBefore(child, insertBefore);
    }
  }

  function optionValues(select) {
    var values = [];
    for (var i = 0; i < select.options.length; i++) {
      values.push(select.options[i].value);
    }
    return values;
  }

  function getPickerMode(select, values) {
    var label = getOptionLabel(select);
    if (label === 'material') return 'material';
    if (label === 'finish' || label === 'color') return 'color';
    var withSwatch = 0;
    values.forEach(function (v) {
      if (swatchUrl(v)) withSwatch++;
    });
    if (withSwatch > 0 && withSwatch >= Math.ceil(values.length / 2)) return 'color';
    return 'text';
  }

  function shouldEnhance(select, values) {
    if (select.closest('.msp-pdp-variant-picker')) return false;
    if (select.classList.contains('msp-pdp-buybox__master-select')) return false;
    if (values.length < 1) return false;

    var label = getOptionLabel(select);
    if (label === 'material' || label === 'finish' || label === 'color') return true;

    if (values.length === 1 && swatchUrl(values[0])) return true;

    if (values.length < 2) return false;

    var withSwatch = 0;
    values.forEach(function (v) {
      if (swatchUrl(v)) withSwatch++;
    });
    return withSwatch > 0;
  }

  function removeStraySoloPickers() {
    document.querySelectorAll('.msp-pdp-variant-picker--solo').forEach(function (el) {
      el.remove();
    });
  }

  function buildChip(value, mode) {
    if (mode === 'text') return null;

    var chip = document.createElement('span');
    chip.className = 'msp-pdp-variant-picker__chip';

    if (mode === 'material') {
      if (isLiteMaterial(value)) {
        chip.classList.add('msp-pdp-variant-picker__chip--material-lite');
      } else if (isSolidMaterial(value)) {
        chip.classList.add('msp-pdp-variant-picker__chip--material-solid');
      } else {
        chip.classList.add('msp-pdp-variant-picker__chip--empty');
      }
      return chip;
    }

    var url = swatchUrl(value);
    if (url) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.width = 32;
      img.height = 32;
      chip.appendChild(img);
      return chip;
    }

    var material = getSelectedMaterial();
    if (isLiteMaterial(material)) {
      chip.classList.add('msp-pdp-variant-picker__chip--hollow');
      return chip;
    }
    if (isSolidMaterial(material)) {
      chip.classList.add('msp-pdp-variant-picker__chip--filled');
      return chip;
    }

    chip.classList.add('msp-pdp-variant-picker__chip--empty');
    return chip;
  }

  function closeAllPickers(except) {
    document.querySelectorAll('.msp-pdp-variant-picker.is-open').forEach(function (picker) {
      if (except && picker === except) return;
      picker.classList.remove('is-open');
      var trigger = picker.querySelector('.msp-pdp-variant-picker__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var menu = picker.querySelector('.msp-pdp-variant-picker__menu');
      if (menu) menu.hidden = true;
    });
  }

  function syncPickerUI(picker, value, mode) {
    var valueEl = picker.querySelector('.msp-pdp-variant-picker__value');
    var chipSlot = picker.querySelector('.msp-pdp-variant-picker__chip-slot');
    if (!valueEl) return;

    valueEl.textContent = value;
    if (chipSlot) {
      chipSlot.innerHTML = '';
      var chip = buildChip(value, mode);
      if (chip) chipSlot.appendChild(chip);
    }

    picker.querySelectorAll('.msp-pdp-variant-picker__option').forEach(function (btn) {
      var selected = btn.getAttribute('data-value') === value;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
  }

  function refreshPickerOptionChips(picker, mode) {
    picker.querySelectorAll('.msp-pdp-variant-picker__option').forEach(function (btn) {
      var optionValue = btn.getAttribute('data-value');
      var existing = btn.querySelector('.msp-pdp-variant-picker__chip');
      if (existing) existing.remove();
      var chip = buildChip(optionValue, mode);
      if (chip) btn.insertBefore(chip, btn.firstChild);
    });
  }

  function refreshColorPickers() {
    document.querySelectorAll('.msp-pdp-variant-picker[data-mode="color"]').forEach(function (picker) {
      var select = picker.parentElement && picker.parentElement.querySelector('.single-option-selector');
      if (!select) return;
      refreshPickerOptionChips(picker, 'color');
      syncPickerUI(picker, select.value, 'color');
    });
  }

  function enhanceSelect(select) {
    var values = optionValues(select);
    if (!shouldEnhance(select, values)) return;

    var wrapper = select.closest('.selector-wrapper');
    if (!wrapper || wrapper.dataset.mspPickerEnhanced) return;
    wrapper.dataset.mspPickerEnhanced = 'true';

    var mode = getPickerMode(select, values);
    var label = wrapper.querySelector('label');
    var picker = document.createElement('div');
    picker.className = 'msp-pdp-variant-picker';
    picker.setAttribute('data-mode', mode);
    if (mode === 'text') {
      picker.classList.add('msp-pdp-variant-picker--no-chip');
    }

    var control = document.createElement('div');
    control.className = 'msp-pdp-variant-picker__control';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'msp-pdp-variant-picker__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var chipSlot = null;
    if (mode === 'color' || mode === 'material') {
      chipSlot = document.createElement('span');
      chipSlot.className = 'msp-pdp-variant-picker__chip-slot';
      trigger.appendChild(chipSlot);
    }

    var valueEl = document.createElement('span');
    valueEl.className = 'msp-pdp-variant-picker__value';

    var caret = document.createElement('span');
    caret.className = 'msp-pdp-variant-picker__caret';
    caret.setAttribute('aria-hidden', 'true');

    trigger.appendChild(valueEl);
    trigger.appendChild(caret);

    var menu = document.createElement('ul');
    menu.className = 'msp-pdp-variant-picker__menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    values.forEach(function (value) {
      var item = document.createElement('li');
      item.setAttribute('role', 'none');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'msp-pdp-variant-picker__option';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-value', value);

      var chip = buildChip(value, mode);
      if (chip) btn.appendChild(chip);

      var text = document.createElement('span');
      text.className = 'msp-pdp-variant-picker__option-label';
      text.textContent = value;
      btn.appendChild(text);

      btn.addEventListener('click', function () {
        if (select.value !== value) {
          select.value = value;
          if (window.jQuery) {
            jQuery(select).trigger('change');
          } else {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        closeAllPickers();
        syncPickerUI(picker, value, mode);
      });

      item.appendChild(btn);
      menu.appendChild(item);
    });

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (values.length < 2) return;
      var open = picker.classList.contains('is-open');
      closeAllPickers();
      if (!open) {
        picker.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }
    });

    if (values.length < 2) {
      picker.classList.add('msp-pdp-variant-picker--single');
    }

    control.appendChild(trigger);
    control.appendChild(menu);
    picker.appendChild(control);

    if (label) {
      picker.insertBefore(label, control);
    }

    select.classList.add('msp-pdp-variant-picker__native');
    wrapper.insertBefore(picker, select);
    wrapper.appendChild(select);

    syncPickerUI(picker, select.value, mode);

    select.addEventListener('change', function () {
      syncPickerUI(picker, select.value, mode);
      if (mode === 'material') {
        refreshColorPickers();
      }
    });
  }

  function enhanceVariantPickers() {
    document.querySelectorAll('#msp-pdp-buybox .single-option-selector').forEach(enhanceSelect);
  }

  function initPdpBuybox() {
    removeStraySoloPickers();
    organizeBuybox();
    enhanceVariantPickers();
  }

  window.MSP.initPdpBuybox = initPdpBuybox;

  function watchBuyboxOptions() {
    var host = document.querySelector('.msp-pdp-buybox__options');
    if (!host || host.dataset.mspBuyboxWatch) return;
    host.dataset.mspBuyboxWatch = 'true';
    var observer = new MutationObserver(function () {
      removeStraySoloPickers();
      enhanceVariantPickers();
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  function scheduleInit() {
    watchBuyboxOptions();
    // theme.liquid runs init after OptionSelectors; these passes catch late DOM only.
    setTimeout(initPdpBuybox, 100);
    setTimeout(initPdpBuybox, 400);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.msp-pdp-variant-picker')) {
      closeAllPickers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPickers();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  if (window.jQuery) {
    jQuery(scheduleInit);
  }
})();
